/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import { Route, Switch } from "react-router";

import Billing from "pages/billing/components/billing/billing";

import * as routes from "./routes";

export const Router = () => {
  return (
    <React.Fragment>
      <Switch>
        <Route
          exact
          path={routes.BILLING_PATH}
          render={(props) => {
            return <Billing {...props} />;
          }}
        />
      </Switch>
    </React.Fragment>
  );
};
